"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
  Form: File Upload
  Unified Fields Props Definition
*/
exports.default = {
    fields: {
        myFileUpload: {
            type: 'file',
            hooks: {
                onDrop: field => console.log('onDrop', field.files),
                // onSubmit: field => console.log('onSubmit', field.files),
            },
        },
        myDropZone: {
            type: 'file',
            hooks: {
                onDrop: field => console.log('onDrop', field.files),
                // onSubmit: field => console.log('onSubmit', field.files),
            },
        },
    },
};
